import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import PublicLayout from "sections/PublicLayout";

function AboutUs() {
  return (
    <PublicLayout
      eyebrow="A1 Institute"
      title="About Us"
      subtitle="ISO 9001:2015 certified · Serving Delhi NCR since our first classroom"
    >
      <Container>
        <Grid container justifyContent="center" sx={{ py: { xs: 3, md: 5 } }}>
          <Grid item xs={12} md={9} lg={8}>
            <MKBox mb={4}>
              <MKTypography variant="h4" mb={1.5}>
                Welcome to A-1 Home Tutors
              </MKTypography>
              <MKTypography variant="body2" color="text">
                A1 Institute is the foremost Eductaional Platform to performing the best ettiquote
                to reforming structural development of Education Volumes. It also believes to
                prospering the educational nurturing so that child can continuing develop his mental
                calierity, mental nurturing, paramount value in his /her cognitive conscions. We
                also believe to promote appendix of huge or Oceanic glance of knowledge with,
                scientific parbalises. In the present acon, A1 Institute Establish fundamental
                approached to student in regard to students mental cliberity.
              </MKTypography>
            </MKBox>

            <MKBox>
              <MKTypography variant="h5" mb={1.5}>
                Result
              </MKTypography>
              <MKTypography variant="body2" color="text">
                Our fundamental laxal aim of achieving the zenith of paramount knowledge to
                spreading it at global segment. Today we must need to co-operate massive enchancing
                to correlate of enjoying amenities of modern education apparatus. Indeed we intend
                to emphosis a moral laxity among student in the contemporary era, we endeavour our
                best to uplifting educational standard by and bound. It is our pledgeful duty to
                encourage the level of high standard of education dynamic in present in scientfic
                scenerio.
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </PublicLayout>
  );
}

export default AboutUs;
